import React from 'react';
import Spinner from 'react-spinkit';


const LongBadgeComponent = ({ name, dataCurrent, dataPrevious, progressData, progressDataPrevious, is_loading = false }) => {

    let progressValue = (dataCurrent - dataPrevious) / dataPrevious * 100;

    let progressDataColorClass = progressValue >= 0 ? 'cards-income-increase' : 'cards-income-decrease';
    let dataSizeStyle = dataCurrent > 99999 ? '__small' : '';
    let dataPreviousSizeStyle = dataPrevious > 99999 ? '__small' : '';

    return <div className='cards-badge' >
        <div className='cards-badge-header'>
            <p>{name}</p>
        </div>
        <div className='cards-badge-body'>
            {is_loading ? (
                    <div
                        className='spinner-loading'
                        style={{ paddingTop: '15px', paddingBottom: '65px', textAlign: 'center' }}
                    >
                        <Spinner name='folding-cube' fadeIn='none' />
                    </div>
            ) : (

                <>
                    <div className='cards-long-badge-text'>
                        <p className='cards-title-name'>Текущие</p>
                        <p className={`cards-badge-value${dataSizeStyle}`}>$ {Math.floor(dataCurrent).toLocaleString('en-US', { useGrouping: true }).replace(/,/g, ' ')}</p>
                        {progressData && (
                            <div className='cards-badge-container'>
                                <progress
                                    className='cards-badge-progress'
                                    value={progressData.value}
                                    max={progressData.max}>
                                </progress>
                                <div class="progress-value">{progressData.value}%</div>
                            </div>
                        )}
                    </div>

                    <div className='cards-long-badge-text'>
                        <div className='cards-divider'></div>
                        {!progressData && (
                            <p className={`cards-income-change ${progressDataColorClass}`}>{Math.floor(progressValue).toLocaleString('en-US', { useGrouping: true }).replace(/,/g, ' ')} %</p>
                        )}
                    </div>
                    <div className='cards-long-badge-text'>
                        <p className='cards-title-name'>Предыдущие</p>
                        <p className={`cards-badge-value-prev${dataPreviousSizeStyle}`}>$ {Math.floor(dataPrevious).toLocaleString('en-US', { useGrouping: true }).replace(/,/g, ' ')}</p>
                        {progressDataPrevious && (
                            <div className='cards-badge-container'>
                                <progress
                                    className='cards-badge-progress'
                                    value={progressDataPrevious.value}
                                    max={progressDataPrevious.max}>
                                </progress>
                                <div class="progress-value">{progressDataPrevious.value}%</div>
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    </div>;
};

export default LongBadgeComponent;